"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var injection_js_1 = require("injection-js");
var client_1 = require("../api/core/client");
var resource_1 = require("../api/core/resource");
var tokenManager_1 = require("../api/core/tokenManager");
var config_1 = require("../config");
var requestAdapter_1 = require("./requestAdapter");
var resourceEndpoints = (_a = {},
    _a[resource_1.ResourceType.Dataset] = config_1.API.DATA.ENDPOINT,
    _a[resource_1.ResourceType.Fileset] = config_1.API.FILES.ENDPOINT,
    _a[resource_1.ResourceType.Channel] = config_1.API.CHANNEL.ENDPOINT,
    _a);
var RequestExecuter = (function () {
    function RequestExecuter(config, systemInit, requestAdapter, tokenManager) {
        this.config = config;
        this.systemInit = systemInit;
        this.requestAdapter = requestAdapter;
        this.tokenManager = tokenManager;
    }
    RequestExecuter.prototype.executeRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var URI, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.systemInit];
                    case 1:
                        _a.sent();
                        URI = this.getUrl(request) + this.parseQueryParams(request);
                        return [4, this.getRequestOptions(request)];
                    case 2:
                        options = _a.sent();
                        return [2, this.requestAdapter.execute(URI, options)];
                }
            });
        });
    };
    RequestExecuter.prototype.getRequestOptions = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var token, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.tokenManager.token(this.config.auth)];
                    case 1:
                        token = _a.sent();
                        options = {
                            headers: { Authorization: "Bearer " + token },
                            method: request.method,
                        };
                        if (this.hasBody(request)) {
                            options.body = request.body;
                        }
                        return [2, options];
                }
            });
        });
    };
    RequestExecuter.prototype.hasBody = function (_a) {
        var method = _a.method;
        return ![requestAdapter_1.RequestMethod.GET, requestAdapter_1.RequestMethod.DELETE].includes(method);
    };
    RequestExecuter.prototype.parseQueryParams = function (_a) {
        var _b = _a.queryParams, queryParams = _b === void 0 ? [] : _b;
        if (!queryParams.length) {
            return "";
        }
        var encodeValue = function (v) { return encodeURIComponent(typeof v === "string" ? v : JSON.stringify(v)); };
        var toQueryParam = function (_a) {
            var key = _a.key, value = _a.value;
            return key + "=" + encodeValue(value);
        };
        return "?" + queryParams
            .map(toQueryParam)
            .join("&");
    };
    RequestExecuter.prototype.getUrl = function (_a) {
        var resourceType = _a.resourceType, resourceName = _a.resourceName;
        var endpoint = resourceEndpoints[resourceType];
        return [
            config_1.API.PROTOCOL + "://" + this.config.projectID + "." + config_1.API.HOST + "." + config_1.API.DOMAIN + ":" + config_1.API.PORT,
            endpoint,
            resourceName,
        ].join("/");
    };
    RequestExecuter = __decorate([
        injection_js_1.Injectable(),
        __param(0, injection_js_1.Inject(tokenManager_1.AuthOptions)),
        __param(1, injection_js_1.Inject(client_1.ClientInit)),
        __metadata("design:paramtypes", [Object, Promise, requestAdapter_1.RequestAdapter,
            tokenManager_1.TokenManager])
    ], RequestExecuter);
    return RequestExecuter;
}());
exports.RequestExecuter = RequestExecuter;
